const HowWodzoneWorks = () => {  
  
  return (
    <div className="user-setting-container help home mb-100">
      <h1 className='HWW-title'>Vous n'êtes plus qu'à 3 étapes de votre prochain défi&nbsp;!</h1>
      <section className="w-100p border-bottom">
        <div className="HWW-texte-container mt-72">
          <img alt="HWW-image" src="/images/search.png" className="HWW-image first-column" id=""></img>
          <div className="text-container second-column">
            <h2 className='fw-700 fz-26'>1. Découvrez</h2>
            <p className="fw-500 fz-18">
              Commencez par découvrir les différentes compétitions. Utilisez des filtres pour affiner vos recherches 
              (par exemple, Team de 2, Inter ou bien encore Cash Prize). 
              Vous pouvez aussi enregistrer vos compétitions préférés dans vos favoris.
            </p>
          </div>
        </div>
        <div className="HWW-texte-container reverse mt-48">
          <img alt="HWW-image" src="/images/search_2.png" className="HWW-image" id=""></img>
          <div className="text-container">
            <h2 className='fw-700 fz-26'>2. Inscrivez-vous</h2>
            <p className="fw-500 fz-18">
              Dès que vous trouvez la compétition qui vous convient, apprenez-en davantage sur l'organisation, la caractéristiques des WODs proposés, les standards
              et vérifiez les options d'annulation applicables, puis réservez en quelques clics.
            </p>
          </div>
        </div>
        <div className="HWW-texte-container mt-48">
          <img alt="HWW-image" src="/images/search_3.png" className="HWW-image first-column" id=""></img>
          <div className="text-container second-column">
            <h2 className='fw-700 fz-26'>3. Affûtez votre performance</h2>
            <p className="fw-500 fz-18">
              Vous avez terminé ! Préparez-vous sans relâche et n'hésitez pas à contacter l'organisateur ou à nous contacter à tout moment pour obtenir plus d'aide.
            </p>
          </div>
        </div>
      </section>
      <section className="w-100p pt-80">
        <h2 className='fw-700 fz-32'>Nous sommes toujours là pour vous aider</h2>
        <div className="HWW-help-container">
          <div className="HWW-card">
            <img alt="HWW-image" src="/images/performance.png" className="HWW-card-image"></img>
            <p className="fw-600 fz-18 mb-4">Une interface simple, intuitive et efficace.</p>
            <p className="fw-500 fz-16">
              Allie performance et simplicité, avec un design intuitif, optimisé du mobile à l’ordinateur.
            </p>
          </div>
          <div className="HWW-card">
            <img alt="HWW-image" src="/images/options.png" className="HWW-card-image"></img>
            <p className="fw-600 fz-18 mb-4">Plus d'options d'annulation</p>
            <p className="fw-500 fz-16">
              Les Organisateurs peuvent offrir différentes options d'annulation, qui sont clairement indiquées dans la page compétition.
            </p>
          </div>
          <div className="HWW-card">
            <img alt="HWW-image" src="/images/assistance.png" className="HWW-card-image"></img>
            <p className="fw-600 fz-18 mb-4">Une assistance à tout moment, jour et nuit</p>
            <p className="fw-500 fz-16">
              Avec une assistance utilisateurs disponible 24h/24, nous sommes là pour vous chaque fois que vous avez besoin d'aide.
            </p>
          </div>
        </div>
      </section>
      <section className="w-100p pt-64">
        <div className="HWW-banner">
          <div className="HWW-banner-text">
            <p className="HWW-banner-text-text">Commençons<br/>votre recherche</p>
            <a href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`} target='_blank' className="HWW-button">
              Découvrir dès maintenant
            </a>
          </div>
          {/* <img alt="HWW-image" src="/images/banner_compets.png" className="HWW-compets-banner"></img> */}
        </div>
      </section>
    </div>
  )
}

export default HowWodzoneWorks